import { isNil } from 'lodash';
import { PacingBlockV2 } from 'shared/src/api/line-item-types';
import { ISODateRange } from 'shared/src/date-string-utils/types';
import { daysBetween } from 'shared/src/date-string-utils/date-utils';
import { UnitPriceType } from 'shared/src/domain/line-item/line-item-channels';
import { getUnitName } from 'shared/src/domain/line-item/line-item-utils';
import { formatCurrency } from '@/components/tables/table-utils';
import { formatCompactUnits } from '@/features/line-items/line-item-form/ui/number-format';

export const blockColors = ['bg-purple-500', 'bg-teal-500', 'bg-blue-500', 'bg-pink-500'];

export function genColor(idx: number): string {
  return blockColors[idx % blockColors.length];
}

export function blockUnits(budget: number | undefined, unit_cost: number | undefined): string {
  if (isNil(budget) || isNil(unit_cost) || unit_cost <= 0) return '';
  return formatCompactUnits(Math.round(budget / unit_cost));
}

export function dailyUnits(block: PacingBlockV2, unit_cost: number | undefined): string {
  const { budget, dates } = block;
  if (isNil(budget) || isNil(unit_cost) || unit_cost <= 0) return '';
  if (!dates?.from || !dates?.to) return '';
  const days = daysBetween(dates.from, dates.to);
  if (days <= 0) return '';
  return formatCompactUnits(Math.round(budget / unit_cost / days));
}

export function dailyBudget(budget: number | undefined, dates: ISODateRange | undefined): string {
  if (isNil(budget) || !dates?.from || !dates?.to) return '';
  const days = daysBetween(dates.from, dates.to);
  if (days <= 0) return '';
  return formatCurrency(budget / days);
}

export function unitShortLabel(
  unit_price_type_id: number | null | undefined,
  unitPriceTypes: UnitPriceType[]
): string {
  const unitPriceType = unitPriceTypes.find(type => type.id === unit_price_type_id);
  return unitPriceType ? getUnitName(unitPriceType.name).abbr : '';
}

export function unitLabel(
  unit_price_type_id: number | null | undefined,
  unitPriceTypes: UnitPriceType[]
): string {
  const unitPriceType = unitPriceTypes.find(type => type.id === unit_price_type_id);
  return unitPriceType ? getUnitName(unitPriceType.name).full : '';
}
